import { NgFor, NgIf } from '@angular/common'
import { HttpParams } from '@angular/common/http'
import { Component, effect, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjChartModule } from '@grapecity/wijmo.angular2.chart'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseComponent, ColumnChart, ListItem, TimeUnit } from '../../../shared'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-adj-gross-margin-pct',
    templateUrl: './adj-gross-margin-pct.component.html',
    styleUrls: ['./adj-gross-margin-pct.component.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule, NgIf, WjChartModule, AutoSizeDirective, NgFor],
})
export class adjGrossMarginPctComponent extends BaseComponent {
    active = input(0)

    startDate: Date = new Date(new Date().getFullYear() - 10, 0, 1)
    endDate: Date = new Date()
    minDate = new Date(2012, 0, 1)
    maxDate = new Date()

    timeUnits: ListItem<number>[] = [
        new ListItem(TimeUnit.Year, 'Year'),
        new ListItem(TimeUnit.Quarter, 'Quarter'),
        new ListItem(TimeUnit.Month, 'Month'),
    ]
    selectedTimeUnit = 7

    jobTypesList: ListItem<string>[] = []
    selectedJobType = ''

    chartData!: ColumnChart

    constructor() {
        super()

        effect(() => {
            if (this.active() == 8) {
                // The analytics.component.ts will have already loaded the jobTypes items.
                this.jobTypesList = this.services.data.jobTypes.items.map(x => new ListItem(x.id, x.shortName))
                this.jobTypesList.unshift(new ListItem(null as any, 'No Job Type'))
                this.jobTypesList.unshift(new ListItem(this.services.utility.emptyGuid(), 'All Job Types'))
                this.selectedJobType = this.services.utility.emptyGuid()
            }
        })
    }

    refresh() {
        if (this.active() !== 8) return
        const params = new HttpParams()
            .set('jobType', this.selectedJobType)
            .set('startDate', this.startDate.toISOString())
            .set('endDate', this.endDate.toISOString())
            .set('timeUnit', this.selectedTimeUnit.toString())
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(this.active() === 8, true, this.services.data.get('/api/Analytics/GetAdjGrossMarginPct', params))
                .subscribe({
                    next: result => {
                        this.chartData = result[0]
                    },
                }),
        )
    }
}
